import { createCheggInstance } from '@chegg/optimizely-sdk';
import config from "../../config";
var optimizelyClient;
var env = process.env.CHEGG_ENV || 'test';
export function setOptimizelyClient() {
  if (typeof window !== 'undefined') {
    /**
     * When initializing with both the SDK key and datafile, the SDK will use the given datafile to start,
     * then download the latest version of the datafile in the background.
     * https://docs.developers.optimizely.com/full-stack/v4.0/docs/initialize-sdk-javascript
     */

    var _config$optimizelyCon = config[env].optimizelyConfig,
      project_id = _config$optimizelyCon.project_id,
      cookieDomain = _config$optimizelyCon.cookieDomain,
      sdkKey = _config$optimizelyCon.sdkKey;
    var _createCheggInstance = createCheggInstance({
        cookieDomain: cookieDomain,
        sdkKey: sdkKey,
        datafile: window.optimizelyDatafile,
        rioConfig: {
          project_id: project_id,
          default_allocation_id_type: 'chegg_visitor_id'
        },
        queryStringOnPageLoad: window.location.search
      }),
      optimizely = _createCheggInstance.optimizely;
    optimizelyClient = optimizely;
    return optimizelyClient;
  }
}
export function getOptimizelyClient() {
  if (!optimizelyClient) {
    setOptimizelyClient();
  }
  return optimizelyClient;
}